import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { QRIcon } from '@base/src/app/models/qr-icon.model';

@Component({
  selector: 'app-rendition-delete-rendition',
  templateUrl: './rendition-delete-rendition.component.html',
  styleUrls: ['./rendition-delete-rendition.component.scss'],
})
export class RenditionDeleteRenditionComponent implements OnInit {
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  value: any;
  address = '';
  id = 0;

  readonly ICON_WARNING = Constants.ICONS.WARNING;
  readonly ICON_COLOR_WHITE = QRIcon.COLOR_WHITE;

  ngOnInit(): void {
    if (this.value) {
      this.address = this.value.name;

      const dialogEvent = {
        isButtonActionDisabled: false,
        value: this.value.id,
      };

      this.dialogChange.emit(dialogEvent);
    }
  }
}
